
import colors from '../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
        ciro: {
            display: 'flex',
            paddingBottom: '15px'
        },
        ciroImage: {
            height: '28px',
            width: '107.69px'
        },
        ciroImageFr: {
            height: '32px',
            width: '107.69px'
        },
        ciroLink: {
            '&[disabled]': {
                cursor: 'default',
                pointerEvents: 'none'
            },
            alignSelf: 'start',
            color: colors[mode].footerLinkDesColor,
            display: 'block',
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontWeight: 400,
            height: '16px',
            letterSpacing: '0',
            lineHeight: '16px'
        },
        divider: {
            margin: '10px'
        },
        fab: {
            '&:hover': {
                background: '#1A4677'
            },
            '@media screen and (max-width: 500px)': {
                right: '10px'
            },
            background: '#003168',
            height: '40px',
            position: 'relative',
            right: '0',
            // top: '130px',
            width: '40px'
        },
        fabUpArrow: {
            height: '11.82px',
            width: '18px'
        },
        flex: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: '33px'
        },
        footer: {
            background: colors[mode].primaryBackground,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            marginTop: 'auto',
            maxWidth: '100vw',
            overflowX: 'hidden',
            padding: '2% 4% 0 4%',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                padding: '0 3%'
            },
            [theme.breakpoints.down('xs')]: {
                padding: '0 2%'
            }
        },
        footerCIRO: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: '2em',
            paddingBottom: '6em'
        },
        footerCIROText: {
            '@media screen and (max-width: 450px)': {
                marginTop: '0px'
            },
            marginLeft: '20px',
            marginTop: '10px'
        },
        footerOutter: {
            background: colors[mode].primaryBackground,
            boxSizing: 'border-box',
            display: 'grid',
            gridTemplateColumns: '2.5fr 9%',
            maxWidth: '100vw',
            overflowX: 'hidden',
            width: '100%'
        },
        footerRBC: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginTop: '1em',
            maxWidth: '100%',
            width: '100%'
        },
        footerRBCText: {
            boxSizing: 'border-box',
            flex: '1 1 auto',
            marginLeft: '40px',
            maxWidth: 'calc(100% - 130px)',
            minWidth: 0,
            [theme.breakpoints.down('sm')]: {
                marginLeft: '20px',
                maxWidth: 'calc(100% - 110px)'
            },
            [theme.breakpoints.down('xs')]: {
                marginLeft: '0',
                marginTop: '20px',
                maxWidth: '100%'
            }
        },
        footerTop: {
            '@media screen and (max-width: 500px)': {
                paddingRight: '10px'
            },
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'flex-end',
            overflow: 'visible',
            paddingRight: '20px',
            position: 'relative',
            width: '100%'
        },
        iirocText: {
            margin: '10px 0 0 0'
        },
        keyboardArrowUp: {
            color: '#FFFFFF'
        },
        link: {
            boxSizing: 'border-box',
            color: colors[mode].footerLinkColor,
            fontFamily: 'Roboto',
            fontSize: '14px',
            height: '16px',
            letterSpacing: 0,
            lineHeight: '16px',
            maxWidth: '100%',
            [theme.breakpoints.down('sm')]: {
                fontSize: '12px'
            }
        },
        linkBelow: {
            [theme.breakpoints.down('xs')]: {
                marginBottom: '7px'
            },
            marginBottom: '8px'
        },
        linkDisabled: {
            cursor: 'default',
            opacity: 0.95,
            pointerEvents: 'none'
        },
        logo: {
            height: '40px',
            margin: '3em 0 2em 0',
            width: '88px'
        },
        logoContainer: {
            '&:hover': {
                cursor: 'pointer'
            },
            alignItems: 'flex-start',
            display: 'flex',
            justifyContent: 'flex-start',
            marginTop: '-10px'
        },
        logoEn: {
            height: '67px',
            width: '89px'
        },
        logoFr: {
            height: '67px',
            width: '89px'
        },
        svg: {
            height: '23px',
            width: '209px'
        },
        text: {
            [theme.breakpoints.down('xs')]: {
                width: 'calc(100%)'
            },
            '@media screen and (max-width: 450px)': {
                width: '85%'
            },
            color: colors[mode].footerLinkDesColor,
            fontFamily: 'Roboto',
            fontSize: '12px',
            letterSpacing: 0,
            lineHeight: '16px',
            width: '59%'
        },
        topButton: {
            
            alignSelf: 'anchor-center',
            
            justifySelf :'center'
        },
        usefulLinks: {
            marginTop: '30px'
        },
        verticalLine: {
            borderRight: 'thin solid #eeb234',
            height: '2rem',
            margin: '2rem 2rem'
        }
    }
}